import ApiService from "./ApiService"

export async function apiGetUsers (data) {
    return ApiService.fetchData({
        url: `/users${data.query?.length > 0 ? `?name=${data.query}` : ''}`,
        method: 'get'
    })
}

export async function apiGetUserById (id) {
    return ApiService.fetchData({
        url: `/users/${id}`,
        method: 'get'
    })
}

export async function apiCreateUser (data) {
    return ApiService.fetchData({
        url: '/auth/sign-up',
        method: 'post',
        data
    })
}

export async function apiUpdateUser (data) {
    return ApiService.fetchData({
        url: `/user/${data.id}`,
        method: 'put',
        data: data.user
    })
}

export async function apiGetRoles () {
    return ApiService.fetchData({
        url: '/roles',
        method: 'get',
    })
}

export async function apiDeleteUser (data) {
    return ApiService.fetchData({
        url: `/user/${data.id}`,
        method: 'delete'
    })
}